export const featureFlags = {
    notificationBroadcast: true,
    pointsSystem: true,
    pointsModeration: false,
    visibleArea: true,
    newWorkerMemo: true,
    pagination: true,
    transactions:true
}
